import React from 'react';
import colored from '../assets/weicare-logo-colored.png';
import white from '../assets/weicare-logo-white.png';
import { COMPANY } from '../config/brand';

/**
 * The Wei Care logo (supplied 2026-10-06). `variant="white"` for dark or
 * photo backgrounds (the home hero); colour everywhere else. Height comes
 * from `className` (e.g. "h-9"); width follows the image.
 */
const Logo = ({ variant = 'color', className = 'h-9' }) => (
  <img src={variant === 'white' ? white : colored} alt={COMPANY.tradingName} className={`${className} w-auto select-none`} draggable="false" />
);

export default Logo;
